module.exports = __webpack_public_path__ + "img/151.06560ed3.jpg";